<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.tipos"
                    :validations="validations.tipo"
                    label="Tipo unidade"
                    v-model="model.tipoId"
                    value-field="id"
                    text-field="descricao"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.esferasAdministrativas"
                    :validations="validations.esferaAdministrativa"
                    label="Esfera administrativa"
                    v-model="model.esferaAdministrativaId"
                    value-field="id"
                    text-field="descricao"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :searchFields="form.autocompleteFields.gestor"
                    :repository="repositories.usuario"
                    v-model="model.gestor"
                    :validations="validations.gestor"
                    label="Gestor"
                    text-field="cidadaoNome"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.naturezasJuridicas"
                    :validations="validations.naturezaJuridica"
                    label="Natureza jurídica"
                    v-model="model.naturezaJuridicaId"
                    value-field="id"
                    text-field="descricao"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    :validations="validations.cnes"
                    label="CNES"
                    v-model="model.cnes"
                    number
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox
                    :label="false"
                    inline
                    v-model="model.pertenceSus"
                >
                    Pertence ao SUS
                </rkm-form-checkbox>

                <rkm-form-checkbox
                    :label="false"
                    inline
                    v-model="model.unidadeReferencia"
                >
                    Unidade de referência
                </rkm-form-checkbox>

                <rkm-form-checkbox
                    :label="false"
                    inline
                    v-model="model.unidadePrestadora"
                >
                    Unidade prestadora
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
import { repository } from '@/mixins'

export default {
    mixins: [ repository ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        repositories: {
            usuario: null,
        },
    }),
    computed: {
        validations() {
            return {
                tipo: { required: true },
                esferaAdministrativa: { required: true },
                gestor: { required: false },
                naturezaJuridica: { required: true },
                cnes: {
                    required: false,
                    min: 7,
                    max: 7,
                },
            }
        }
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
    },
    created() {

        this.repositories.usuario = this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario')
    },
}
</script>